import React from "react";
import { PRIVACY_HTML, TERMS_HTML, DATADEL_HTML } from "@/legal/legalContent";

const MAP = { privacy: PRIVACY_HTML, terms: TERMS_HTML, "data-deletion": DATADEL_HTML };

// Standalone legal pages rendered in an isolated iframe so their styling
// stays exact and never leaks into the app.
export default function LegalPage({ page }) {
  const html = MAP[page] || PRIVACY_HTML;
  return (
    <iframe
      title={page}
      srcDoc={html}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: "none", background: "#0A0A0A" }}
    />
  );
}
